$(function(){
  $('.autoTypedText').each(function() {
    $(this).typedText();
  });
})

$.fn.typedText = function() {
  var textElement = $(this);
  textElement.data('counter', 0);
  textElement.data('text', textElement.text().trim());
  textElement.data('typedText', '');
  textElement.height(textElement.height());

  typeLetter();


  function typeLetter(){
    var text = textElement.data('text');
    var counter = textElement.data('counter');

    if (textElement.data('counter') == 0 || textElement.data('counter') >= text.length) {
      textElement.text('');
      counter = 0;
      textElement.data('counter', 0);
      textElement.removeData(['startDeletingAt', 'lettersToDelete']); // forget about deleting letters
      textElement.data('typedText', '');
    }

    if (textElement.attr('data-typos') == "true" && Math.random() < 0.2 && textElement.data('startDeletingAt') == undefined) {
      var lettersToDelete = getNumberOfLettersToDelete();
      console.log('lettersToDelete', lettersToDelete);
      console.log('counter', counter);
      console.log('startDeletingAt', counter + lettersToDelete);
      var randomLetter = getRandomLetter();
      textElement.data().typedText += randomLetter;
      textElement.html(textElement.text().substr(0, counter) + '<span class="error">' + getRandomLetter() + '</span>|');
      textElement.data('startDeletingAt', counter + lettersToDelete);
      textElement.data('lettersToDelete', lettersToDelete);
    }
    else {
      textElement.data().typedText += text[textElement.data('counter')];
      textElement.html(textElement.text().substr(0, textElement.data('counter')) + '<b>' + text[textElement.data('counter')] + '</b>|');
    }

    textElement.data().counter++;
    counter++;

    if (textElement.data('startDeletingAt') && textElement.data('startDeletingAt') == counter) {
      console.log('start deleting!')
      setTimeout(function() { deleteLetter(textElement.data('lettersToDelete'), true); }, 1000);
    }
    else {
      var speed = parseInt(textElement.attr('data-speed'));
      var speedWithDeviation = (textElement.attr('data-randomDelays') == "true") ? addRandomDeviation(speed, 80) : speed;
      var delayBetweenLetters = 60000 / speedWithDeviation; // = 1/(speedWithDeviation/60)*1000;
      if (textElement.data('counter') >= text.length) {
        delayBetweenLetters = 3000; // when the text is all typed, have a little break before deleting it
        textElement.html(textElement.html().substr(0, textElement.html().length - 1));
      }

      setTimeout(typeLetter, delayBetweenLetters);
    }
  }

  function getRandomLetter() {
    var chars = 'abcdefghijklmnopqrstuvwxyz';
    return chars.charAt(Math.floor(Math.random() * chars.length));
  }

  function deleteLetter(lettersToDelete, isFirstLetterInSequence) {
    if (lettersToDelete == 1) {
      textElement.html(textElement.text().substr(0, textElement.data('counter') - 1));  // this also deletes <span class="error"></span>
      console.log('counterr', textElement.data('counter'));
    }
    else {
      var koef = isFirstLetterInSequence ? 9 : 2;
      textElement.html(textElement.html().substr(0, textElement.html().length - koef));  // includes deleting the cursor
    }
    textElement.data().typedText = textElement.data().typedText.substr(0, textElement.data('counter'));
    textElement.data().counter--;

    console.log('deleteLetter', lettersToDelete);
    if (lettersToDelete > 1) {
      setTimeout(function() { deleteLetter(lettersToDelete - 1, false); }, 150);
    }
    else {
      textElement.removeData(['startDeletingAt', 'lettersToDelete']);
      setTimeout(typeLetter, 500); 
    }
  }

  // randomly delete 1-5 letters, not more than the length of the text
  function getNumberOfLettersToDelete() {

    var distribution = [1,2,2,2,3,3,3,4,5,6];
    var lettersToDelete = distribution[Math.floor(Math.random() * distribution.length)];  // 0-9

    return lettersToDelete; 
  }

  function addRandomDeviation(speed, maxDeviation) {
    var random = Math.random()
    if(random > 0.75) return speed + maxDeviation;
    else if(random > 0.5) return speed + maxDeviation/2;
    else if(random > 0.25) return speed - maxDeviation/2;
    else return speed - maxDeviation;
  }

}


/*
- 1 z 10, vrátit se náhodně o 1-5 znaků, max. o délku textu
- vracení rychlé (400/min?)

 */